(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-list"] && !Shopify.designMode) return;
  try {
    
  async function randomizeHomepageProducts(configElement) {
    const section = configElement.closest('[data-testid="product-list"]');
    const lists = Array.from(section.querySelectorAll(':scope > .resource-list'));
    const currentItems = Array.from(lists[0]?.querySelectorAll('.resource-list__item') ?? []);
    const { sectionId, productCount, pageSize, pageParam, currentPage } = JSON.parse(configElement.textContent);
    if (productCount < 2 || currentItems.length === 0) return;

    const indices = Array.from({ length: productCount }, (_, index) => index);
    const count = Math.min(pageSize, productCount);

    for (let index = 0; index < count; index++) {
      const randomIndex = index + Math.floor(Math.random() * (productCount - index));
      [indices[index], indices[randomIndex]] = [indices[randomIndex], indices[index]];
    }

    const selected = indices.slice(0, count);
    const pages = new Map([[currentPage, currentItems]]);
    const neededPages = [...new Set(selected.map((index) => Math.floor(index / pageSize) + 1))];

    try {
      await Promise.all(
        neededPages.map(async (page) => {
          if (pages.has(page)) return;

          const url = new URL(window.location.href);
          url.searchParams.delete('sections');
          url.searchParams.set('section_id', sectionId);
          url.searchParams.set(pageParam, String(page));
          const response = await fetch(url, { signal: AbortSignal.timeout(5000) });
          if (!response.ok) throw new Error('Product list request failed');

          const html = new DOMParser().parseFromString(await response.text(), 'text/html');
          const renderedSection = html.querySelector('[data-testid="product-list"]');
          const renderedConfig = renderedSection?.querySelector('[data-random-products]');
          if (!renderedConfig || JSON.parse(renderedConfig.textContent).currentPage !== page) {
            throw new Error('Product list page unavailable');
          }

          const items = renderedSection.querySelector('.resource-list')?.querySelectorAll('.resource-list__item');
          pages.set(page, Array.from(items ?? []));
        })
      );

      const products = selected.map((index) => pages.get(Math.floor(index / pageSize) + 1)?.[index % pageSize]);
      const productIds = products.map((item) => item?.querySelector('product-card')?.dataset.productId);
      if (productIds.some((id) => !id) || new Set(productIds).size !== count || !section.isConnected) return;

      const replacements = lists.map((list, listIndex) => ({
        items: Array.from(list.querySelectorAll('.resource-list__item')),
        products: products.map((item, index) => {
          const clone = item.cloneNode(true);
          clone.querySelector('product-card').id = `${sectionId}-random-product-${productIds[index]}-${listIndex}`;
          return clone;
        }),
      }));
      if (replacements.some(({ items }) => items.length !== count)) return;

      for (const { items, products } of replacements) {
        items.forEach((item, index) => item.replaceWith(products[index]));
      }
    } catch {
      return;
    }
  }

  document.querySelectorAll('[data-random-products]').forEach(randomizeHomepageProducts);

  } catch(e) { console.error(e); }
})();
})();
